// Operation queue to prevent race conditions (ES5 compatible)
var isProcessingCartOperation = false;
var operationQueue = [];

// Process operations one by one
function processOperationQueue() {
  if (isProcessingCartOperation || operationQueue.length === 0) return;
  
  isProcessingCartOperation = true;
  var operation = operationQueue.shift();
  
  operation()
    .then(function() {
      isProcessingCartOperation = false;
      // Process next operation after a small delay
      setTimeout(processOperationQueue, 100);
    })
    .catch(function(error) {
      isProcessingCartOperation = false;
      setTimeout(processOperationQueue, 100);
    });
}

// Helper to attach add-to-cart behavior to current forms
function bindMasterCollectionAddToCart() {
  var forms = document.querySelectorAll('.add-to-cart-form');
  
  for (var i = 0; i < forms.length; i++) {
    var form = forms[i];
    
    // Skip if already bound to prevent duplicate listeners
    if (form.dataset.bound) {
      continue;
    }
    form.dataset.bound = 'true';
    
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var button = e.target.querySelector('.add-to-cart-btn');
      var variantId = e.target.querySelector('[name="id"]').value;
      var cartDrawer = document.querySelector('cart-drawer');
      var originalText = button.textContent;


      // Prevent multiple submissions
      if (button.disabled || button.classList.contains('loading')) {
        return;
      }
      
      // Add to operation queue
      operationQueue.push(function() {
        return performAddToCart(button, variantId, cartDrawer, originalText);
      });
      processOperationQueue();
    });
  }
}

// Extracted add to cart function for better control
function performAddToCart(button, variantId, cartDrawer, originalText) {
  // Set loading state
  button.disabled = true;
  button.classList.add('loading');
  button.textContent = 'Adding...';

  return fetch(routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: { _slpt: "" },
      sections: cartDrawer ? ['cart-drawer'] : [],
      sections_url: window.location.pathname
    })
  })
  .then(function(response) {
    if (!response.ok) {
      return response.json().then(function(error) {
        button.textContent = 'Error';
        return new Promise(function(resolve) {
          setTimeout(function() {
            button.textContent = originalText;
            button.disabled = false;
            button.classList.remove('loading');
            resolve();
          }, 2000);
        });
      });
    }

    return response.json().then(function(parsedState) {
      // Show success feedback
      button.textContent = 'Added!';
      
      // Open cart drawer
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
        cartDrawer.open();
      }
      
      // Wait before resetting
      return new Promise(function(resolve) {
        setTimeout(function() {
          button.textContent = originalText;
          button.disabled = false;
          button.classList.remove('loading');
          resolve();
        }, 1500);
      });
    });
  })
  .catch(function(error) {
    button.textContent = 'Error';
    return new Promise(function(resolve) {
      setTimeout(function() {
        button.textContent = originalText;
        button.disabled = false;
        button.classList.remove('loading');
        resolve();
      }, 2000);
    });
  });
}

// Helper to prevent card link click when button is pressed
function bindMasterCollectionCardButtons() {
  var cartButtons = document.querySelectorAll('.add-to-cart-btn');

  for (var i = 0; i < cartButtons.length; i++) {
    cartButtons[i].addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }
}

function syncMasterCollectionSubscriptionContext() {
  var cfg = window.masterCollectionSubscription;
  var root = document.getElementById('home-collection');
  if (!cfg || !root) return;
  var sub = root.querySelector('.mgrid-subscribe__radio--subscribe');
  cfg.subscriptionOn = !!(sub && sub.checked);
}

function subscriptionAdjustedCents(baseCents, cfg) {
  if (!cfg || !cfg.subscriptionOn) return baseCents;
  if (cfg.discountType === 'percentage') {
    var p = Math.min(100, Math.max(0, Number(cfg.discountPercent) || 0));
    return Math.round(baseCents * (100 - p) / 100);
  }
  var off = Math.max(0, parseInt(cfg.discountAmountCents, 10) || 0);
  return Math.max(0, baseCents - off);
}

function formatMasterCollectionMoney(cents) {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }
  return (cents / 100).toFixed(2);
}

function refreshMasterCollectionGridPrices() {
  var cfg = window.masterCollectionSubscription;
  var root = document.getElementById('home-collection');
  if (!cfg || !root) return;

  syncMasterCollectionSubscriptionContext();

  var els = root.querySelectorAll('[data-mgrid-selling-cents]');
  for (var i = 0; i < els.length; i++) {
    var el = els[i];
    var base = parseInt(el.getAttribute('data-mgrid-selling-cents'), 10);
    if (isNaN(base)) continue;
    var out = subscriptionAdjustedCents(base, cfg);
    el.textContent = formatMasterCollectionMoney(out);
  }

  var sheet = root.querySelector('.mgrid-subscribe__sheet');
  if (sheet) {
    if (cfg.subscriptionOn) {
      sheet.classList.add('mgrid-subscribe__sheet--open');
      sheet.setAttribute('aria-hidden', 'false');
    } else {
      sheet.classList.remove('mgrid-subscribe__sheet--open');
      sheet.setAttribute('aria-hidden', 'true');
    }
  }
}

function bindMasterCollectionSubscribeToggle() {
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') return;
    if (!t.classList || !t.classList.contains('mgrid-subscribe__radio')) return;
    refreshMasterCollectionGridPrices();
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  bindMasterCollectionAddToCart();
  bindMasterCollectionCardButtons();
  bindMasterCollectionSubscribeToggle();
  refreshMasterCollectionGridPrices();
});